import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import styles from './MileageSaarathi.module.css';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import CustomPopover_ace from './Popover';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

const InsightsTable_ace = forwardRef(({ filterdata, setFleetInsightLoading, activeTab }, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [bestVehicles, setBestVehicles] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(bestVehicles.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = bestVehicles.slice(indexOfFirstItem, indexOfLastItem);

  const [targetEnergyEfficiencyData, setTaTargetEnergyEfficiencyData] = useState({})

  useEffect(() => {
    setFleetInsightLoading(true)
    fetchData(
      {
        url: API_URL_MAIN + `mileage_sarathi_ace/fleet_summary_target_energy_efficiency`,
        body: {
          filterdata: {
            ...filterdata,
            VIN_NUM: [],
            REG_NUM: []
          }
        }
      },
      (data) => {

        const result = data?.reduce((acc, item) => {
          const id = item.key.vehicleId;
          const value = item.Target_Energy_Efficiency.value;
          acc[id] = value;
          return acc;
        }, {});
        setTaTargetEnergyEfficiencyData(result)
        setFleetInsightLoading(false)
      })
  }, [filterdata])

  useImperativeHandle(ref, () => ({
    downloadData: () => {
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const excelFileName = "Insights Report";


      const flatData = bestVehicles?.map((item, index) => ({
        'Sr. no': index + 1,
        'Vin': item?.vinNo,
        // 'Register Number': "",
        // 'Driving Score':"",
        'Energy Efficiency': Number(item?.EnergyEfficiency)?.toFixed(2) + ' KWh/Km',
        'Target Efficiency': Number(item?.targetEnergyEff)?.toFixed(2) + ' KWh/Km',
        'RPM': item.RPM > 17 ? 'Compliant' : 'Non-Compliant',
        'Speed': item.Speed > 18 ? 'Compliant' : 'Non-Compliant',
        'Accelerator Pedal': item.AccelerationSpeed > 30 ? 'Compliant' : 'Non-Compliant',
        "Idling": item.Idling > 35 ? 'Compliant' : 'Non-Compliant',
        'Coasting': item.Costing > 9.10 ? 'Compliant' : 'Non-Compliant',
        'Regeneration': item.Regeneration > 30 ? 'Compliant' : 'Non-Compliant',
        // 'Breaking':""
      }));

      const ws = XLSX.utils.json_to_sheet(flatData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, excelFileName + fileExtension);

    }
  }));
  useEffect(() => {
    // const apiEnd = 'mileage_sarathi_ace/fleet_summary_insight_fleet';
    // activeTab === "community" or "fleet"
    const apiEnd =
      activeTab === "community"
        ? "mileage_sarathi_ace/fleet_summary_insight"
        : "mileage_sarathi_ace/fleet_summary_insight_fleet";

    setFleetInsightLoading(true)
    fetchData(
      {
        url: API_URL_MAIN + apiEnd,
        body: { filterdata },
      },
      (data) => {
        const vehicles = data?.results?.map((bucket) => ({
          RegNo: bucket.key.vehicleId,
          vinNo: bucket.key.vehicleId,
          DrivingScore: bucket.Driving_Score.value?.toFixed(2) ?? '-',
          EnergyEfficiency: bucket.Energy_Efficiency?.value ?? '-',
          EnergyEfficiencyBenchmark: bucket.Energy_Efficiency_Benchmark?.value ?? '-',
          RPM: bucket.RPM?.value ?? '-',
          Speed: bucket.Speed?.value ?? '-',
          AccelerationSpeed: bucket.Accelerator_Pedal?.value ?? '-',
          Idling: bucket.Idling?.value ?? '-',
          Costing: bucket.Coasting?.value ?? '-',
          Regeneration: bucket.Regeneration?.value ?? '-',
          Braking: bucket.Braking?.value ?? '-',
          // targetEnergyEff: targetEnergyEfficiencyData[bucket?.key?.vehicleId] || null
          targetEnergyEff: bucket.Target_Energy_Efficiency.value ?? '-',
        })) || [];

        setBestVehicles(vehicles);
        setFleetInsightLoading(false)
      }
    );
  }, [filterdata, targetEnergyEfficiencyData, activeTab]);

  const renderTag = (value, vehicleId = '', key = '') => {
    let isCompliant = false;

    if (value === '-' || value === null || value === undefined) {
      return <span>{value}</span>;
    }


    const num = Number(value);
    switch (key) {
      case 'Speed':
        isCompliant = num > 25;
        break;
      case 'Idling':
        isCompliant = num < 22;
        break;
      case 'AccelerationSpeed':
        isCompliant = num > 19;
        break;
      case 'Regeneration':
        isCompliant = num > 8.72;
        break;
      case 'RPM':
        isCompliant = num > 17;
        break;
      case 'Costing':
        isCompliant = num > 9.10;
        break;
      default:
        return <span>{value?.toFixed(2)}</span>;
    }

    const label = isCompliant ? 'Compliant' : 'Non-Compliant';
    const badgeStyle = {
      padding: '2px 6px',
      borderRadius: '4px',
      fontWeight: '600',
      fontSize: '12px',
      color: isCompliant ? '#27aa57' : '#c92a31', // dark green / dark red text
      backgroundColor: isCompliant ? '#CEECD9' : '#f4d3d4', // green / red background
      border: `no border`,
    };

    return <span style={badgeStyle}>{label}
      <CustomPopover_ace keyName={key} value={value} filterdata={{ ...filterdata, VIN_NUM: [vehicleId] }} />
    </span>;
  };

  const resetScrollPosition = () => {
    const scrollable = document.getElementById('scrollable-section');
    scrollable.scrollTo({ left: 0, behavior: 'smooth' });
  };

  const scrollToEnd = () => {
    const scrollable = document.getElementById('scrollable-section');
    scrollable.scrollTo({ left: scrollable.scrollWidth, behavior: 'smooth' });
  };

  if (isLoading) return <div>Loading Insights...</div>;
  // if (error) return <div>Error loading insights.</div>;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };
  return (
    <div className="position-relative">

      <div className={`${styles.insights_grid_wrapper}`}>

        {/* Fixed Column Table */}
        <div className={styles.insights_fixed_col_wrapper}>
          <table className={`table table-bordered m-0 ${styles.insights_fixed_col_table}`}>
            <thead>
              <tr className={styles.insights_fixed_col_tableheader}>
                <th>Reg. No.</th>
                <th>Driving Score</th>
                <th>Energy Efficiency</th>
                <th>Target Energy Efficiency</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((vehicle) => (
                <tr key={vehicle.RegNo} className={styles.insights_fixed_col_tabledata}>
                  <td><span style={{ fontSize: "12px" }}>{vehicle.RegNo}</span></td>
                  <td>{vehicle.DrivingScore}</td>
                  <td>{renderTag(vehicle.EnergyEfficiency)}</td>
                  <td>{vehicle.targetEnergyEff || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Scrollable Table */}
        <div className={styles.insights_scroll_sec}>
          <div className="d-flex align-items-center position-relative">
            <button
              className={`scroll-arrow ${styles.insights_scroll_arrow} ${styles.left}`}
              onClick={resetScrollPosition}
            >
              &#9664;
            </button>

            <div id="scrollable-section" className={`hide-scrollbar ${styles.insights_scroll}`}>
              <table className={`table table-bordered m-0 ${styles.insights_scroll_table}`} style={{ fontSize: '14px' }}>
                <thead>
                  <tr className={styles.insights_scroll_tablerow}>
                    <th style={{ minWidth: '120px' }}>RPM</th>
                    <th style={{ minWidth: '120px' }}>Speed</th>
                    <th style={{ minWidth: '160px' }}>Accelerator Pedal</th>
                    <th style={{ minWidth: '120px' }}>Idling</th>
                    <th style={{ minWidth: '120px' }}>Coasting</th>
                    <th style={{ minWidth: '160px' }}>Regeneration</th>
                    <th style={{ minWidth: '120px' }}>Braking</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((vehicle) => (
                    <tr key={vehicle.RegNo} className={styles.insights_scroll_tabledata}>
                      <td>{renderTag(vehicle.RPM, vehicle?.vinNo, "RPM")}</td>
                      <td>{renderTag(vehicle.Speed, vehicle?.vinNo, 'Speed')}</td>
                      <td>{renderTag(vehicle.AccelerationSpeed, vehicle?.vinNo, 'AccelerationSpeed')}</td>
                      <td>{renderTag(vehicle.Idling, vehicle?.vinNo, 'Idling')}</td>
                      <td>{renderTag(vehicle.Costing, vehicle?.vinNo, "Costing")}</td>
                      <td>{renderTag(vehicle.Regeneration, vehicle?.vinNo, 'Regeneration')}</td>
                      <td>{renderTag(vehicle.Braking)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              className={`scroll-arrow ${styles.insights_scroll_arrow} ${styles.right}`}
              onClick={scrollToEnd}
            >
              &#9654;
            </button>
          </div>
        </div>

      </div>

      {/* </div> */}

      {currentItems?.length ?
        <>
          <div className="small text-muted mt-2">
            Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, bestVehicles.length)} of {bestVehicles.length} entries
          </div>
          <div className="d-flex justify-content-center mt-3 align-items-center">

            <button
              className={`${currentPage === 1 ? "btn btn-link" : styles.ms_button}`}
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >
              <i className={`fas fa-chevron-left ms_button`}></i> Prev
            </button>

            {/* Show first page and ellipsis if needed */}
            {currentPage > 3 && (
              <>
                <button
                  className={`mx-1 ${currentPage === 1 ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                  onClick={() => handlePageChange(1)}
                >
                  1
                </button>
                {currentPage !== 4 && <span className="mx-1">...</span>}
              </>
            )}

            {/* Middle page buttons */}
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(page =>
                page === currentPage ||
                page === currentPage - 1 ||
                page === currentPage + 1
              )
              .map(page => (
                <button
                  key={page}
                  className={`mx-1 btn btn-sm ${currentPage === page ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              ))}

            {/* Show last page and ellipsis if needed */}
            {currentPage < totalPages - 2 && (
              <>
                {currentPage !== totalPages - 3 && <span className="mx-1">...</span>}
                <button
                  className={`mx-1 btn btn-sm ${currentPage === totalPages ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                  onClick={() => handlePageChange(totalPages)}
                >
                  {totalPages}
                </button>
              </>
            )}

            <button
              className={` ${currentPage === totalPages ? "btn btn-link" : styles.ms_button}`}
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </> : <></>
      }
    </div>
  );
})

export default InsightsTable_ace;
